import React from 'react';
import { BrandIcon } from './icons';
import { usePressSpring } from '../hooks/usePressSpring';
import { showStoreUnavailable } from '../utils/storeToast';
import { useLanguage } from '../i18n/LanguageContext';
import { cx } from '../utils/cx';
import mixins from '../styles/mixins.module.css';

function StoreLink({ href, icon, small, label, toastLabel, compact, lang }) {
  const ref = usePressSpring(mixins.pressed);
  const className = cx(mixins.store, mixins.spring, compact && mixins.storeCompact);
  const content = (
    <>
      <BrandIcon name={icon} />
      <span>
        <small>{small}</small>
        <b>{label}</b>
      </span>
    </>
  );

  if (href) {
    return (
      <a
        ref={ref}
        className={className}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        {content}
      </a>
    );
  }

  // No real link yet — stays a real button (focusable, correct semantics)
  // and shows a toast instead of navigating anywhere.
  return (
    <button
      ref={ref}
      type="button"
      className={className}
      onClick={(e) => {
        e.stopPropagation();
        showStoreUnavailable(toastLabel, lang);
      }}
    >
      {content}
    </button>
  );
}

// Always renders both store buttons — a missing link shows a toast on
// click rather than being omitted.
export default function StoreButtons({ app, compact = false }) {
  const { t, lang } = useLanguage();
  return (
    <>
      <StoreLink
        href={app.appStore}
        icon="apple"
        small={t('storeDownloadOn')}
        label={t('storeAppStore')}
        toastLabel={t('storeAppStore')}
        compact={compact}
        lang={lang}
      />
      {!app.hideGooglePlay && (
        <StoreLink
          href={app.googlePlay}
          icon="play"
          small={t('storeGetItOn')}
          label={t('storeGooglePlay')}
          toastLabel={t('storeGooglePlay')}
          compact={compact}
          lang={lang}
        />
      )}
    </>
  );
}
